/**
 * frontend/src/lib/marque-cliente.ts
 * `#837` — **LA MARQUE CLIENTE SE LIT, ELLE NE S'ÉCRIT PLUS** (`#815`).
 * `#839` — **PROMU DU LABO AU SOCLE**, comme `lib/mots.ts` : le chrome peint le
 *   nom du client dans sa barre latérale. *Inventer une seconde lecture serait
 *   le motif `#498` — un contrôle de plus à maintenir est un contrôle qui
 *   divergera.*
 *
 * ══════════════════════════════════════════════════════════════════════════════
 * ⚠⚠ **CE QUE LE T0 `#835` A MESURÉ, ET QUI REVENAIT ICI.**
 * ══════════════════════════════════════════════════════════════════════════════
 *   *Le Labo **peignait `Samsung (défaut)`** (`FlowRanking.tsx:230`,
 *   `UnifiedBrandControl.tsx:112`), écrivait `IHS Samsung (%)` et donnait
 *   `ex. Sell-out Samsung Retail CENTRE ytd` en exemple de modale. Le module
 *   précédent (Exactitude) était **le seul du chantier exempt du défaut** ; le
 *   Labo le ramenait en entier.*
 *
 * ⚠ **MÊME SOURCE QUE LE COMPARATEUR ET BRAND VS BRAND** : `useRefBrands()` et
 *   son `isClientBrand`. *Ne pas inventer une seconde source serait le motif
 *   `#498` : un contrôle de plus à maintenir est un contrôle qui divergera.*
 *
 * ⚠⚠ **ET LE CODE RESTE, LUI** : *`SAMSUNG` en repli n'est pas un libellé
 *   d'écran, c'est **une valeur de contrat** — le back applique ce défaut quand
 *   `brand_ctx` est vide. On ne le traduit pas et on ne le retire pas ; on
 *   cesse seulement de le PEINDRE. Le repli textuel (`Samsung`) est le même que
 *   celui de `PriceSearchForm.tsx:223` — un produit, un repli.*
 */
import { useRefBrands } from '@/modules/referentials/hooks/useRefBrands';

/** Code marque par défaut côté contrat back (`ranking.brand_ctx` vide). */
export const CODE_MARQUE_DEFAUT = 'SAMSUNG';

export interface MarqueCliente {
  /** Le NOM lisible, celui qui va à l'écran. */
  nom: string;
  /** Le CODE, celui qui va au payload. */
  code: string;
}

export function useMarqueCliente(): MarqueCliente {
  const { data } = useRefBrands();
  const m = data?.find((b) => b.isClientBrand) ?? null;
  return { nom: m?.name ?? 'Samsung', code: m?.code ?? CODE_MARQUE_DEFAUT };
}
